require("./global/global");
require("./password-recovery/index");


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/password-recovery.js